import { WizardCardProps } from './WizardCard';

export const WIZARD_CARD_COLOR_SCHEMES: Record<string, WizardCardProps['colorScheme']> = {
  blue: {
    borderColor: '#2196f3',
    titleColor: '#1976d2',
    gradientColors: ['#2196f3', '#21cbf3'],
    backgroundGradient: ['#ffffff', '#e3f2fd']
  },
  green: {
    borderColor: '#4caf50',
    titleColor: '#388e3c',
    gradientColors: ['#4caf50', '#8bc34a'],
    backgroundGradient: ['#ffffff', '#e8f5e8']
  },
  orange: {
    borderColor: '#ff9800',
    titleColor: '#f57c00',
    gradientColors: ['#ff9800', '#ffc107'],
    backgroundGradient: ['#ffffff', '#fff3e0']
  },
  pink: {
    borderColor: '#e91e63',
    titleColor: '#c2185b',
    gradientColors: ['#e91e63', '#f06292'],
    backgroundGradient: ['#ffffff', '#fce4ec']
  },
  purple: {
    borderColor: '#9c27b0',
    titleColor: '#7b1fa2',
    gradientColors: ['#9c27b0', '#ba68c8'],
    backgroundGradient: ['#ffffff', '#f3e5f5']
  }
};

export const WIZARD_CARD_PRESETS = {
  step1: {
    colorScheme: WIZARD_CARD_COLOR_SCHEMES.blue,
    rotation: 0
  },
  step2: {
    colorScheme: WIZARD_CARD_COLOR_SCHEMES.green,
    rotation: 72
  },
  step3: {
    colorScheme: WIZARD_CARD_COLOR_SCHEMES.orange,
    rotation: 144
  },
  step4: {
    colorScheme: WIZARD_CARD_COLOR_SCHEMES.pink,
    rotation: 216
  },
  step5: {
    colorScheme: WIZARD_CARD_COLOR_SCHEMES.purple,
    rotation: 288
  }
};
